import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CarePlan`;

export const getCareGoalsByCarePlan = async (carePlanId) => {
try {
    const url = `${API_URL}/${carePlanId}/goals`;

    const response = await axios.get(url, {
    headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    });

    return response.data;
    } catch (error) {
        console.error("Error fetching care goals:", error);
        throw error;
    }
};
